import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { BreederProfileBreedPropTypes } from 'dpl/shared/utils/customPropTypes';
import { isEqualFormValues } from 'dpl/shared/form/utils';
import SmartImage from 'dpl/components/SmartImage';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';

const BREED_INPUT_NAME = 'breed_id';

export default function QuizBreederBreedQuestion({
  availableBreeds,
  formState,
  handleNextClick,
  onChange,
  isValid
}) {
  const selectedBreed = formState[BREED_INPUT_NAME] || '';

  return (
    <div className="AdoptionApplicationQuizBreederBreedQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        isValid={isValid}
        title="Which breed are you interested in?"
      >
        <ul className="mb14 row justify-center">
          {availableBreeds.map(
            ({ id, name, cover_photo_url: coverPhotoUrl }) => {
              const isSelected = isEqualFormValues(selectedBreed, id);
              const htmlId = `${BREED_INPUT_NAME}-${id}`;

              return (
                <li className="col-sm-6 mb8" key={htmlId}>
                  <label
                    className={classnames(
                      'AdoptionApplicationQuizBreederBreedQuestion__label transition h-100 db ba br1 bw1 pointer relative f0',
                      {
                        'b--black-20': !isSelected,
                        'b--purple': isSelected
                      }
                    )}
                    htmlFor={htmlId}
                  >
                    <input
                      checked={isSelected}
                      className="f0 outline-0 absolute d-none"
                      id={htmlId}
                      name={BREED_INPUT_NAME}
                      onClick={() => onChange('breed_id', id, handleNextClick)}
                      onChange={() => null}
                      type="radio"
                      value={id}
                    />
                    <div className="flex items-center ph2 pv2">
                      <SmartImage
                        Tag="div"
                        className="cover bg-center mr4"
                        height="56px"
                        src={coverPhotoUrl}
                        width="56px"
                      />
                      <span className="f3 fw-medium tl truncate">{name}</span>
                    </div>
                  </label>
                </li>
              );
            }
          )}
        </ul>
      </FullPageQuizQuestion>
    </div>
  );
}

QuizBreederBreedQuestion.propTypes = {
  availableBreeds: PropTypes.arrayOf(
    PropTypes.shape(BreederProfileBreedPropTypes)
  ).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired
};
